import { render, staticRenderFns } from "./archive-space.vue?vue&type=template&id=63389b63&scoped=true"
import script from "./archive-space.vue?vue&type=script&lang=js"
export * from "./archive-space.vue?vue&type=script&lang=js"
import style0 from "./archive-space.vue?vue&type=style&index=0&id=63389b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63389b63",
  null
  
)

export default component.exports